import React from 'react'
import { Outlet } from 'react-router-dom'

const RaiseComplaintOutlet = () => {
  return (
    <div>
        <Outlet></Outlet>
    </div>
  )
}

export default RaiseComplaintOutlet